<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-newspaper-variant-outline
          </v-icon>
          テナントユーザー
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForms.contractor_name"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="法人名"
                        persistent-placeholder
                        clearable
                        placeholder="部分一致"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForms.tenant_name"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="テナント名"
                        persistent-placeholder
                        clearable
                        placeholder="部分一致"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForms.user_name"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="ユーザー名"
                        persistent-placeholder
                        clearable
                        placeholder="部分一致"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="searchForms.unlinked_only"
                        dense
                        hide-details="auto"
                        label="アカウントロックのみ表示"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
 
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="users"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.contractor_name`]="{ item }">
                {{ item.contractor_name }}
              </template>
              <template v-slot:[`item.tenant_name`]="{ item }">
                {{ item.tenant_name }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                {{ item.name }}
              </template>
              <template v-slot:[`item.login_id`]="{ item }">
                {{ item.login_id }}
              </template>
              <template v-slot:[`item.email`]="{ item }">
                {{ item.email }}
              </template>
              <template v-slot:[`item.last_login_at`]="{ item }">
                {{ item.last_login_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.lock_at`]="{ item }">
                {{ item.lock_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn
                  v-if="item.lock_at && $vuetify.breakpoint.mdAndUp"
                  color="primary"
                  icon
                  @click="unlockButtonClickEvent(item)"
                >
                  <v-icon>mdi-lock-open-variant</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.lock_at && !$vuetify.breakpoint.mdAndUp"
                  text
                  color="primary"
                  @click="unlockButtonClickEvent(item)"
                >
                  解除
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
    <unlock-dialog
      v-model="showUnlockDialog"
      @confirm="handleUnlockConfirm"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../components/Confirm'
import UnlockDialog from './dialogs/UnlockDialog'
export default {
  name: 'TenantUserIndex',
  components: {
    Confirm,
    UnlockDialog,
  },
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      targetId: null,
      targetUserId: null,
      showUnlockDialog: false,
      enableTenantUserDialog: false,
      searchForms: {
        contractor_name: null,
        tenant_name: null,
        user_name: null,
        unlinked_only: true,
      },
      tableHeaders: [
        { value: 'contractor_name', text: '法人名', width: '15%' },
        { value: 'tenant_name', text: 'テナント名', width: '15%' },
        { value: 'name', text: 'ユーザ名', width: '15%' },
        { value: 'login_id', text: 'ログインID', width: '15%' },
        { value: 'email', text: 'メールアドレス', width: '15%' },
        { value: 'last_login_at', text: '最終ログイン日時', width: '10%' },
        { value: 'lock_at', text: 'アカウントロック日時', width: '10%' },
        { value: 'editable', text: '', width: '5%', align: 'end' },
      ],
      users: [],
    }
  },
  computed: {
    ...mapState('AdminTenantUser', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminTenantUser', [
      'hasResult'
    ]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForms.content = this.searchCondition.content
    this.page = this.pagination.current_page
    this.searchTenantUser()
  },
  methods: {
    ...mapActions('AdminTenantUser', {
      fetchTenantUsers: 'index',
      unlockUser: 'update',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableTenantUserDialog = true
    },
    closeTenantUserDialog () {
      this.enableTenantUserDialog = false;
    },
    tenantUserCallback (forms) {
      this.closeTenantUserDialog()
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchTenantUser()
    },
    changePage () {
      this.searchTenantUser()
    },
    searchTenantUser () {
      let params = { 
        contractor_name: this.searchForms.contractor_name,
        tenant_name: this.searchForms.tenant_name,
        user_name: this.searchForms.user_name,
        unlinked_only: this.searchForms.unlinked_only,
        page: this.page,
      }
      this.fetchTenantUsers(params).then((content) => {
        this.users = content.users
        this.total_count = content.pagination.total_count
      })
    },
    unlockButtonClickEvent (item) {
      this.targetUserId = item.id
      this.showUnlockDialog = true
    },
    handleUnlockConfirm () {
      if (this.targetUserId) {
        this.unlockUser({ id: this.targetUserId }).then(() => {
          this.searchTenantUser()
          this.targetUserId = null
        })
      }
    }
  }
}
</script>
